// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"a3f61db6","165":"6f999528","219":"0c719ad6","226":"5b5f1f12","267":"7fefff8f","356":"0ec396d4","453":"aa95871c","638":"465eb3e4","705":"d94acd6e","796":"a65b2647"}[chunkId] + ".chunk.js";
};